/**
 * Moderation API client — T0 Epic D.
 *
 * Buyer reporting (`POST /vehicles/:id/report`) and the admin queue +
 * suspend/reinstate actions. All authenticated (HMAC + JWT).
 */
import { apiGet, apiPost } from '../../../adapters/api-client/api';

export type ReportReason =
  | 'FRAUD'
  | 'MISLEADING'
  | 'INAPPROPRIATE'
  | 'DUPLICATE'
  | 'ALREADY_SOLD'
  | 'OTHER';

export const REPORT_REASON_LABEL: Record<ReportReason, string> = {
  FRAUD: 'Fraude / estafa',
  MISLEADING: 'Información engañosa',
  INAPPROPRIATE: 'Contenido inapropiado',
  DUPLICATE: 'Anuncio duplicado',
  ALREADY_SOLD: 'Ya vendido',
  OTHER: 'Otro',
};

export interface ModerationQueueEntry {
  vehicleId: string;
  title: string;
  status: string;
  reportCount: number;
  reasons: ReportReason[];
  latestReportAt?: string;
  suspensionReason?: string;
}

export function reportListing(
  vehicleId: string,
  reason: ReportReason,
  note?: string,
): Promise<{ report: { reportId: string } }> {
  return apiPost(`/api/v1/vehicles/${vehicleId}/report`, { reason, note });
}

export async function fetchModerationQueue(
  state: 'REPORTED' | 'SUSPENDED' = 'REPORTED',
): Promise<ModerationQueueEntry[]> {
  const res = await apiGet<{ entries: ModerationQueueEntry[] }>(
    `/api/v1/admin/moderation?state=${state}`,
  );
  return res.entries ?? [];
}

export function suspendListing(vehicleId: string, reason: string): Promise<unknown> {
  return apiPost(`/api/v1/admin/vehicles/${vehicleId}/suspend`, { reason });
}

export function reinstateListing(vehicleId: string): Promise<unknown> {
  return apiPost(`/api/v1/admin/vehicles/${vehicleId}/reinstate`, {});
}
